"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.09,11.46V9.1l-4.15,2.35V9L8.22,11.48,6.94,5.35H4.7l-1,7.32v5.86H20.23V9.08Zm-6.22,5h-1a.35.35,0,0,1-.34-.35.34.34,0,0,1,.34-.34h1a.35.35,0,0,1,.35.34A.35.35,0,0,1,9.87,16.46Zm0-2.07h-1A.35.35,0,0,1,8.49,14a.34.34,0,0,1,.34-.34h1a.35.35,0,0,1,.35.34A.35.35,0,0,1,9.87,14.39ZM14,16.46H13a.35.35,0,0,1-.34-.35.34.34,0,0,1,.34-.34h1a.34.34,0,0,1,.35.34A.35.35,0,0,1,14,16.46Zm0-2.07H13a.35.35,0,0,1-.34-.35A.34.34,0,0,1,13,13.7h1a.34.34,0,0,1,.35.34A.35.35,0,0,1,14,14.39Zm4.16,2.07h-1a.35.35,0,0,1-.34-.35.34.34,0,0,1,.34-.34h1a.34.34,0,0,1,.35.34A.35.35,0,0,1,18.19,16.46Zm0-2.07h-1a.35.35,0,0,1-.34-.35.34.34,0,0,1,.34-.34h1a.34.34,0,0,1,.35.34A.35.35,0,0,1,18.19,14.39Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.57,4.2a1.88,1.88,0,0,1,1-.3c1.34,0,2.85,1.25,4.6,1.25,1.38,0,2.63-.79,3.82-2.42a.34.34,0,0,0,0-.46.35.35,0,0,0-.46,0A2.61,2.61,0,0,1,12.7,3c-1.44,0-3-1-4.55-1a3.75,3.75,0,0,0-3,1.75.35.35,0,0,0,.46.5Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;